// Remotion CLI entry point — imports Root with CSS/Tailwind and scenarios
import { registerRoot } from 'remotion';
import RemotionRoot from '../src/remotion/Root.jsx';

registerRoot(RemotionRoot);
